<template>
  <div class="sector-selector">
    <div v-for="(sector2s, sector1) in sectors" :key="sector1" class="sector1">
      <el-checkbox
        :indeterminate="
          value.filter(t => t.startsWith(sector1)).length > 0 &&
          sector2s.length !== value.filter(t => t.startsWith(sector1)).length
        "
        :value="
          sector2s.length === value.filter(t => t.startsWith(sector1)).length
        "
        @change="onL1Change(sector1, $event)"
        :disabled="
          value.filter(t => t.startsWith(sector1)).length === 0 &&
          selectedSector1Count >= maxL1
        "
        >{{ $t(`sector_${sector1}`) }}
      </el-checkbox>
      <el-checkbox-group
        :value="value"
        @input="onInput"
        :disabled="
          value.filter(t => t.startsWith(sector1)).length === 0 &&
          selectedSector1Count >= maxL1
        "
      >
        <el-checkbox v-for="sector2 in sector2s" :label="sector2" :key="sector2"
          >{{ $t(`sector_${sector2}`) }}
        </el-checkbox>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      selected: [],
    };
  },
  props: {
    maxL1: {
      type: Number,
      default: -1,
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    sectors: Object,
  },
  computed: {
    selectedSector1Count() {
      return this.sectors && this.value
        ? Object.keys(this.sectors).filter(t =>
            this.value.find(p => p.startsWith(t)),
          ).length
        : 0;
    },
  },
  methods: {
    onInput(value) {
      this.$emit('input', value);
    },
    onL1Change(sector1, checked) {
      let val = [...this.value];
      if (checked) {
        val.push(...this.sectors[sector1].filter(t => val.indexOf(t) === -1));
      } else {
        val = val.filter(t => !t.startsWith(sector1));
      }
      this.$emit('input', val);
    },
  },
};
</script>
